// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RhO_","right":"styles_right__uDbBr"};